import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../typings/state';
import { CmxHttpClient } from './api.service';
import { ParametersResponse } from '../typings/parameters';
import { catchError, map, retry } from 'rxjs/operators';
import { SetParameters } from '../store/actions';

@Injectable()
export class ParametersService {
  PATH = '/v7/ce/parameters?countryCode=';
  constructor(
    private store: Store<State>,
    private http: CmxHttpClient,
  ) {}

  fetchParameters(countryCode: string) {
    this.http
      .get<ParametersResponse>(this.PATH + countryCode)
      .pipe(
        retry(3),
        map((response) => {
          const parametersData = response.parameters;
          this.store.dispatch(new SetParameters(parametersData));
        }),
        catchError(() => {
          this.store.dispatch(new SetParameters([]));
          return null;
        }),
      )
      .subscribe();
  }
}
